import {lastValueFrom, Observable} from "rxjs";

export abstract class BaseService {
  public async ExecuteAsync<T>(req: Observable<T>): Promise<T> {
    return lastValueFrom(req);
  }

  public mapParams(object: any): string {
    let query = '?';

    const keys = Object.keys(object);
    keys.forEach((x) => {
      if (object[x] !== undefined && object[x] !== null)
        query += `${x}=${object[x]}&`
    });

    return query;
  }
}
